import controller from './notifications.controller';
import template from './notifications.template.html';
import './notifications.styles.scss';

const component = {
	bindings: {

	},
	template,
	controller
};

export default component;



// WEBPACK FOOTER //
// ./src/modules/topbar/components/notifications/index.js